/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Buildseyebrow1Inputs */

const id_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biner`)
};

const ms_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binari`)
};

const da_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binære`)
};

const de_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binärdateien`)
};

const en_us2_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaries`)
};

const es_es2_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binarios`)
};

const es_mx2_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binarios`)
};

const fil_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binary`)
};

const fr_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaires`)
};

const it_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binari`)
};

const hu_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binárisok`)
};

const nl_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaries`)
};

const no_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binærfiler`)
};

const pl_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pliki binarne`)
};

const pt_br2_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binários`)
};

const pt_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binários`)
};

const ro_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binare`)
};

const fi_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaarit`)
};

const sv_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binärfiler`)
};

const vi_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhị phân`)
};

const tr_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İkililer`)
};

const cs_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binárky`)
};

const bg_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бинарни файлове`)
};

const ru_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бинарные файлы`)
};

const uk_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бінарні файли`)
};

const ar_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البرامج الثنائية`)
};

const hi_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाइनरी`)
};

const th_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไบนารี`)
};

const ja_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイナリ`)
};

const zh_cn2_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二进制文件`)
};

const zh_hant1_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二進位制檔案`)
};

const ko_sandboxes_buildseyebrow1 = /** @type {(inputs: Sandboxes_Buildseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`바이너리`)
};

/**
* | output |
* | --- |
* | "Binaries" |
*
* @param {Sandboxes_Buildseyebrow1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_buildseyebrow1 = /** @type {((inputs?: Sandboxes_Buildseyebrow1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Buildseyebrow1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_buildseyebrow1(inputs)
	if (locale === "ms") return ms_sandboxes_buildseyebrow1(inputs)
	if (locale === "da") return da_sandboxes_buildseyebrow1(inputs)
	if (locale === "de") return de_sandboxes_buildseyebrow1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_buildseyebrow1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_buildseyebrow1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_buildseyebrow1(inputs)
	if (locale === "fil") return fil_sandboxes_buildseyebrow1(inputs)
	if (locale === "fr") return fr_sandboxes_buildseyebrow1(inputs)
	if (locale === "it") return it_sandboxes_buildseyebrow1(inputs)
	if (locale === "hu") return hu_sandboxes_buildseyebrow1(inputs)
	if (locale === "nl") return nl_sandboxes_buildseyebrow1(inputs)
	if (locale === "no") return no_sandboxes_buildseyebrow1(inputs)
	if (locale === "pl") return pl_sandboxes_buildseyebrow1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_buildseyebrow1(inputs)
	if (locale === "pt") return pt_sandboxes_buildseyebrow1(inputs)
	if (locale === "ro") return ro_sandboxes_buildseyebrow1(inputs)
	if (locale === "fi") return fi_sandboxes_buildseyebrow1(inputs)
	if (locale === "sv") return sv_sandboxes_buildseyebrow1(inputs)
	if (locale === "vi") return vi_sandboxes_buildseyebrow1(inputs)
	if (locale === "tr") return tr_sandboxes_buildseyebrow1(inputs)
	if (locale === "cs") return cs_sandboxes_buildseyebrow1(inputs)
	if (locale === "bg") return bg_sandboxes_buildseyebrow1(inputs)
	if (locale === "ru") return ru_sandboxes_buildseyebrow1(inputs)
	if (locale === "uk") return uk_sandboxes_buildseyebrow1(inputs)
	if (locale === "ar") return ar_sandboxes_buildseyebrow1(inputs)
	if (locale === "hi") return hi_sandboxes_buildseyebrow1(inputs)
	if (locale === "th") return th_sandboxes_buildseyebrow1(inputs)
	if (locale === "ja") return ja_sandboxes_buildseyebrow1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_buildseyebrow1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_buildseyebrow1(inputs)
	return ko_sandboxes_buildseyebrow1(inputs)
});
export { sandboxes_buildseyebrow1 as "sandboxes.buildsEyebrow" }